type TimeRange = [Date, Date];

const MINUTES_IN_DAY = 24 * 60;

function toMinutes(date: Date): number {
  return (
    date.getHours() * 60 +
    date.getMinutes() +
    date.getSeconds() / 60 +
    date.getMilliseconds() / 60000
  );
}

function isMidnight(date: Date): boolean {
  return (
    date.getHours() === 0 &&
    date.getMinutes() === 0 &&
    date.getSeconds() === 0 &&
    date.getMilliseconds() === 0
  );
}

/**
 * Sprawdza czy zakresy godzinowe (w obrębie jednej doby)
 * NIE nachodzą na siebie
 */
export function areTimeRangesNonOverlapping(ranges: TimeRange[]): boolean {
  const normalized: Array<[number, number]> = [];

  for (const [start, end] of ranges) {
    const s = toMinutes(start);
    const e = toMinutes(end);

    // 00:00 → 00:00 = pełna doba
    if (s === e && isMidnight(start) && isMidnight(end)) {
      normalized.push([0, MINUTES_IN_DAY]);
      continue;
    }

    // inne start === end → zakres zerowy
    if (s === e) continue;

    if (s < e) {
      normalized.push([s, e]);
    } else {
      // zakres nocny
      normalized.push([s, MINUTES_IN_DAY]);
      normalized.push([0, e]);
    }
  }

  normalized.sort((a, b) => a[0] - b[0]);

  for (let i = 1; i < normalized.length; i++) {
    const [, prevEnd] = normalized[i - 1];
    const [currStart] = normalized[i];

    if (currStart < prevEnd) {
      return false;
    }
  }

  return true;
}
